import { render, staticRenderFns } from "./customer.pug?vue&type=template&id=0e27d458&lang=pug&"
import script from "./customer.ts?vue&type=script&lang=ts&"
export * from "./customer.ts?vue&type=script&lang=ts&"
import style0 from "./customer.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports